<template>
    <div class="invoice-card h-100">
        <div class="card-icon" :style="{ color: color}">
            <i :class="['fa', icon]"></i>
        </div>
        <div class="card-content">
            <span class="card-label text-uppercase">{{ label }}</span>
            <div class="card-values">
                <span class="card-value">{{ value }}</span>
                <span v-if="subValue" class="card-subvalue">{{ subValue }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "invoice-summary-card",
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        },
        subValue: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: "#6366F1"
        },
    }
};
</script>

<style lang="scss" scoped>
.invoice-card {
    background: #ffffff;
    border: 1px solid #f3f4f6;
    border-radius: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 20px;
    transition: all 0.2s ease;

    &:hover {
        border-color: #e5e7eb;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
    }

    .card-icon {
        width: 52px;
        height: 52px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
    }

    .card-content {
        display: flex;
        flex-direction: column;

        .card-label {
            font-size: 11px;
            font-weight: 500;
            color: #6B7280;
            letter-spacing: 0.05em;
            margin-bottom: 2px;
        }

        .card-values {
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        .card-value {
            font-size: 20px;
            font-weight: 500;
            color: #111827;
            line-height: 1.2;
        }

        .card-subvalue {
            font-size: 12px;
            font-weight: 400;
            color: #9CA3AF;
        }
    }
}
</style>
